// extracted by mini-css-extract-plugin
export default {"getOutline":"Welcome_getOutline__NVOBW","Welcome":"Welcome_Welcome__fuHRv","ContentFixedButton":"Welcome_ContentFixedButton__U2c+-"};